import { Directive, ElementRef, Input, OnInit } from '@angular/core';

import { AbilityService } from '../services/ability.service';

@Directive({
  selector: '[appAbility]',
  standalone: true,
})
export class AbilityDirective implements OnInit {
  @Input() appAbility: any;
  @Input() type: string = '';

  // Pending with event emiter
  // $scope.$on('listPermissions', toggleVisibilityBasedOnPermission);

  constructor(private elementRef: ElementRef, private abilityService: AbilityService) {}

  ngOnInit(): void {
    this.setAbility();
  }

  private setAbility() {
    const hasPermission =
      this.type === 'feature'
        ? this.abilityService.canFeature(this.appAbility).permitted
        : this.abilityService.can(this.appAbility);

    if (hasPermission) {
      this.elementRef.nativeElement.style.display = 'block';
    } else {
      this.elementRef.nativeElement.style.display = 'none';
    }
  }
}
